const easeInOutQuad = (current_time: number, start: number, change: number, duration: number) => {
  current_time /= duration / 2;
  if (current_time < 1) return (change / 2) * current_time * current_time + start;
  current_time--;
  return (-change / 2) * (current_time * (current_time - 2) - 1) + start;
};

const scrollTo = (start: number, to: number, duration: number) => {
  if (typeof window === `undefined`) return;
  let change = to - start,
    currentTime = 0,
    increment = 10;

  let animateScroll = () => {
    currentTime += increment;
    let val = easeInOutQuad(currentTime, start, change, duration);
    window.scrollTo(0, val);
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };

  animateScroll();
};

import { de, enGB, es, fr } from "date-fns/locale";

const getFnsLocale = (language: string) => {
  switch (language) {
    case "es-ES":
      return es;
    case "en-GB":
      return enGB;
    case "de-DE":
      return de;
    case "fr-FR":
      return fr;
    default:
      return enGB;
  }
};

export { getFnsLocale, scrollTo };
